// extracted by mini-css-extract-plugin
var _1 = "Item_menuItem__lxbIZ";
var _2 = "Item_menuItemText__qH8PH";
export { _1 as "menuItem", _2 as "menuItemText" }
